var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "resize-size" }, [
    _c("div", { staticClass: "resize-size__header" }, [
      _vm.label
        ? _c("label", { staticClass: "resize-size__label" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeDropdown,
              expression: "closeDropdown",
            },
          ],
          staticClass: "resize-size__preset-wrap",
        },
        [
          _c(
            "button",
            {
              staticClass: "resize-size__preset-trigger",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.presetDropdownOpen = !_vm.presetDropdownOpen
                },
              },
            },
            [
              _vm._v("\n        Select preset\n        "),
              _c("b-icon", {
                staticClass: "resize-size__preset-chevron",
                attrs: {
                  icon: _vm.presetDropdownOpen ? "chevron-up" : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.presetDropdownOpen
            ? _c(
                "div",
                { staticClass: "resize-size__preset-dropdown" },
                _vm._l(_vm.presets, function (preset) {
                  return _c(
                    "button",
                    {
                      key: `${preset.width}x${preset.height}`,
                      staticClass: "resize-size__preset-option",
                      class: {
                        "resize-size__preset-option--selected":
                          _vm.isPresetSelected(preset),
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.selectPreset(preset)
                        },
                      },
                    },
                    [
                      _vm.isPresetSelected(preset)
                        ? _c("b-icon", {
                            staticClass: "resize-size__preset-check",
                            attrs: { icon: "check" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: {
                            "resize-size__preset-option-label--offset":
                              !_vm.isPresetSelected(preset),
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(preset.width) +
                              "×" +
                              _vm._s(preset.height) +
                              " px\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.value.length
      ? _c(
          "div",
          { staticClass: "resize-size__chips" },
          _vm._l(_vm.value, function (size, i) {
            return _c(
              "div",
              { key: size.id, staticClass: "resize-size__chip" },
              [
                _c("span", { staticClass: "resize-size__chip-label" }, [
                  _vm._v(
                    _vm._s(size.width) + " × " + _vm._s(size.height) + " px"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "resize-size__chip-remove",
                    attrs: {
                      type: "button",
                      "aria-label": `Remove ${size.width} × ${size.height}`,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.remove(i)
                      },
                    },
                  },
                  [_c("b-icon", { attrs: { icon: "x" } })],
                  1
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "resize-size__input-row" },
      [
        _c("div", { staticClass: "resize-size__size-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.width,
                expression: "width",
                modifiers: { number: true },
              },
            ],
            staticClass: "resize-size__size-field",
            attrs: { type: "number", placeholder: "W", min: "1" },
            domProps: { value: _vm.width },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.add.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.width = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "resize-size__size-sep" }, [_vm._v("×")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.height,
                expression: "height",
                modifiers: { number: true },
              },
            ],
            staticClass: "resize-size__size-field",
            attrs: { type: "number", placeholder: "H", min: "1" },
            domProps: { value: _vm.height },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.add.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.height = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "resize-size__size-unit" }, [_vm._v("px")]),
        ]),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "resize-size__add-btn",
            attrs: {
              variant: "link",
              size: "sm",
              disabled: !_vm.width || !_vm.height,
            },
            on: { click: _vm.add },
          },
          [
            _c("b-icon", { staticClass: "mr-1", attrs: { icon: "plus" } }),
            _vm._v("\n      Add size\n    "),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }